import React from 'react';
import { IonIcon, IonButton } from '@ionic/react';
import { refreshOutline } from 'ionicons/icons';
import hamIcon from '../../assets/ham-icon.svg';
import { Course } from '@/types/course';
import { CourseCard } from './CourseCard';

interface CoursesListProps {
  courses: Course[];
  onToggleSidebar?: () => void;
  selectedCategory?: string;
  onRefresh?: () => Promise<void>;
}

export const CoursesList: React.FC<CoursesListProps> = ({ courses, onToggleSidebar, selectedCategory = 'all', onRefresh }) => {
  const displayTitle = selectedCategory === 'all' ? 'All Courses' : selectedCategory;

  if (courses.length === 0) {
    return (
      <div className="flex-1 flex flex-col overflow-hidden" data-tour="course-tiles-grid">
        <div className="flex-shrink-0 pt-4 px-6">
          <div className="flex items-center gap-4 mb-4">
            <button
              onClick={onToggleSidebar}
              className="lg:hidden flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded transition-colors"
              aria-label="Toggle menu"
            >
              <IonIcon icon={hamIcon} size="small" color="medium" />
            </button>
            <h1 className="text-xl font-bold flex-1">{displayTitle}</h1>
            {onRefresh && (
              <IonButton onClick={onRefresh} fill="clear" className="toolbar-button-icon">
                <IonIcon icon={refreshOutline} slot="icon-only" />
              </IonButton>
            )}
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center p-8">
          <p className="text-gray-500 text-lg">No courses available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col overflow-hidden" data-tour="course-tiles-grid">
      <div className="flex-shrink-0 pt-4 px-6">
        <div className="flex items-center gap-4 mb-4">
          <button
            onClick={onToggleSidebar}
            className="lg:hidden flex items-center justify-center w-10 h-10 hover:bg-gray-100 rounded transition-colors"
            aria-label="Toggle menu"
          >
            <IonIcon icon={hamIcon} size="small" color="medium" />
          </button>
          <h1 className="text-xl font-bold flex-1">{displayTitle}</h1>
          {onRefresh && (
            <IonButton onClick={onRefresh} color="secondary" fill="clear" className="toolbar-button-icon" shape="round">
              <IonIcon icon={refreshOutline} slot="icon-only" />
            </IonButton>
          )}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-6 pb-6">
        <div className="flex flex-wrap gap-6">
          {courses.map((course) => (
            <div key={course.id} className="w-full sm:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)]">
              <CourseCard course={course} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
